import timestampService from "../../../service/timestampService";
import { ganttChartVerticalValues } from "../../../utils/ganttChartValues";
import ganttChartStyles from "../../../styles/ganttChart/ganttChart.module.css";
import { useEffect } from "react";
import ganttChartService from "../../../service/ganttChartService";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setDefaultPixelsPerMinute } from "../../../store/timeline";

const VerticalGanttChartTimelineColumn = () => {
  const dispatch = useAppDispatch();
  const { verticalSvgWidth } = useAppSelector((state) => state.ganttChartSlice);
  const {
    timelineArrayOfTimeString,
    pixelPerMinute,
    timelineRange,
    pixelsPerHour,
  } = useAppSelector((state) => state.timelineSlice);

  useEffect(() => {
    if (timelineRange) {
      dispatch(
        setDefaultPixelsPerMinute(
          ganttChartService.getPixelsPerMinute(timelineRange.hoursInView),
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timelineArrayOfTimeString]);

  return (
    <>
      {timelineRange && pixelsPerHour && (
        <div
          id="gantt-chart-timeline"
          className={ganttChartStyles.verticalTimelineColumn}
          style={{
            position: "absolute",
            left: 0,
            top: -pixelsPerHour / 2,
            width: ganttChartVerticalValues.timelineColumn,
          }}
        >
          {pixelPerMinute &&
            timelineArrayOfTimeString &&
            timelineArrayOfTimeString.map((timePoint, index) => (
              <p
                className="flex items-center justify-start pl-3"
                style={{
                  height: pixelsPerHour,
                  color: "var(--col-text-secondary)",
                }}
                key={index}
              >
                {index !== 0 && (
                  <span>
                    {timestampService.returnTwoDigitTimeString(timePoint.hour)}
                    :
                    {timestampService.returnTwoDigitTimeString(timePoint.minutes)}
                  </span>
                )}
              </p>
            ))}
        </div>
      )}
      {pixelsPerHour &&
        timelineArrayOfTimeString &&
        timelineArrayOfTimeString.map((_, index) => {
          const x = ganttChartVerticalValues.timelineColumn - 20;
          const y = (index + 1) * pixelsPerHour;
          return (
            <div
              key={index + 1}
              style={{
                position: "absolute",
                left: x,
                top: y,
                width: verticalSvgWidth - x,
                height: 1,
                backgroundColor: "var(--col-border-primary)",
                pointerEvents: "none",
              }}
            />
          );
        })}
    </>
  );
};

export default VerticalGanttChartTimelineColumn;
